import React, { useState, lazy } from 'react';
const tomos = [{
  num: '01',
  title: 'El Negocio que Sangra',
  subtitle: 'El diagnóstico que ninguna lashista quiere ver pero todas necesitan',
  desc: 'Cuánto perdés realmente por cada cancelación. La auditoría de pérdidas reales. La proyección a 6 meses. La identidad que te frena. La psicología de la cancelación y el manifiesto de la lashista dueña de su negocio.'
}, {
  num: '02',
  title: 'El Filtro de Acero',
  subtitle: 'Cómo evitar que el problema entre antes de que exista',
  desc: 'Instagram como filtro de clientas. El primer mensaje como detector de riesgo. La seña como herramienta de compromiso. Scripts para cobrar sin inseguridad. El formulario pre-turno y el sistema de semáforo verde-amarillo-rojo para evaluar cada clienta nueva.'
}, {
  num: '03',
  title: 'Políticas de Tolerancia Cero',
  subtitle: 'Las reglas claras que hacen que tu tiempo valga',
  desc: 'Política de llegada tarde. Costo oculto de la tolerancia. Cómo comunicar políticas antes del problema. Sistema de consecuencias. Banco de 30 mensajes de WhatsApp. Sistema de recordatorios 72-24-2. Blacklist estratégico y despedida profesional.'
}, {
  num: '04',
  title: 'La Agenda Invulnerable',
  subtitle: 'El sistema que llena huecos y construye una agenda predecible',
  desc: 'Bloques de oro, plata y bronce. Arquitectura semanal diseñada. Lista de espera activa. Sistema de rellenado de turno en 15 minutos. Club VIP. Plan de 90 días de implementación y el cierre del sistema completo.'
}];
const checklist = ['Sistema listo para implementar desde el día 1', 'Checklists y plantillas para usar de inmediato', 'Scripts y mensajes listos para copiar y pegar', 'Casos reales del contexto de lashistas argentinas', 'Cierre con resumen accionable por tomo', '100% adaptado a la realidad argentina 2025'];
const bonos = [{
  num: '01',
  title: 'Kit Express Anti-Cancelación en 10 Minutos',
  short: 'Mini sistema funcional hoy mismo',
  desc: 'Activá un mini sistema anti-cancelación hoy mismo aunque nunca hayas puesto reglas antes. Tu monto de seña definido, tu política lista, tus mensajes guardados en WhatsApp y tu primer turno blindado. Todo en 10 minutos.',
  value: '$12.000',
  img: 'https://images.unsplash.com/photo-1522337094846-8a818192de1f?auto=format&fit=crop&w=400&q=70',
  alt: 'Aplicación de extensiones de pestañas'
}, {
  num: '02',
  title: '25 Respuestas Rápidas para Clientas que Quieren Cancelar',
  short: '25 mensajes listos para copiar y pegar',
  desc: 'Respondé con firmeza y elegancia cualquier intento de cancelación sin quedarte en blanco ni regalar tu tiempo. 25 mensajes listos para copiar y pegar organizados por escenario, tono y nivel de firmeza.',
  value: '$15.000',
  img: 'https://images.unsplash.com/photo-1556656793-08538906a9f8?auto=format&fit=crop&w=400&q=70',
  alt: 'Mujer respondiendo mensajes en su celular'
}, {
  num: '03',
  title: 'Checklist de Clienta de Riesgo',
  short: 'Semáforo verde-amarillo-rojo',
  desc: 'Detectá en minutos si una clienta tiene perfil de canceladora antes de darle un lugar en tu agenda. Sistema de semáforo verde-amarillo-rojo con 21 señales de alerta y protocolo de decisión para cada color.',
  value: '$12.000',
  img: 'https://images.unsplash.com/photo-1586282391129-76a6df230234?auto=format&fit=crop&w=400&q=70',
  alt: 'Checklist sobre un escritorio'
}, {
  num: '04',
  title: 'Plan de Rescate de Turno Caído',
  short: 'Cubrí el hueco en 15 minutos',
  desc: 'Convertí un turno cancelado en una nueva oportunidad de ingreso en menos de 15 minutos. Protocolo de 6 pasos, mensajes exactos de rescate y sistema de seguimiento para mejorar mes a mes.',
  value: '$12.000',
  img: 'https://images.unsplash.com/photo-1506784983877-45594efa4cbe?auto=format&fit=crop&w=400&q=70',
  alt: 'Agenda con fechas marcadas'
}];
function TomoCard({
  t,
  i
}: {
  t: (typeof tomos)[number];
  i: number;
}) {
  const [open, setOpen] = useState(false);
  return <div className={`bg-[#FAF6F0] border border-[#E8D5C4] rounded-2xl p-4 sm:p-6 md:p-10 hover:border-[#B8956A] transition-all relative overflow-hidden`} data-id="element-175">
      <div className="absolute top-0 right-0 w-24 h-24 sm:w-32 sm:h-32 rounded-bl-full bg-gradient-to-br from-transparent to-[#E8D5C4]/30 -mr-8 -mt-8 sm:-mr-10 sm:-mt-10" data-id="element-176" />
      <div className="relative z-10" data-id="element-177">
        <div className="flex items-baseline gap-2 sm:gap-3 mb-2 sm:mb-4" data-id="element-178">
          <span className="text-4xl sm:text-5xl md:text-6xl text-[#B8956A] font-light italic leading-none" style={{
          fontFamily: "'DM Serif Display', serif"
        }} data-id="element-179">
            {t.num}
          </span>
          <span className="text-[10px] sm:text-xs tracking-[0.25em] text-[#5A2A3D] font-bold uppercase" data-id="element-180">
            Tomo
          </span>
        </div>
        <h3 className="text-lg sm:text-2xl md:text-3xl text-[#2D1A22] mb-1.5 sm:mb-2 leading-tight" data-id="element-181">
          {t.title}
        </h3>
        <p className="text-xs sm:text-sm md:text-base text-[#5A2A3D] italic mb-2 sm:mb-4" data-id="element-182">
          {t.subtitle}
        </p>

        {/* Compact on mobile: hide desc behind toggle */}
        <div className="md:hidden" data-id="element-183">
          {open && <p className="text-[#5A4A4F] leading-relaxed text-xs sm:text-sm mt-2" data-id="element-184">
              {t.desc}
            </p>}
          <button type="button" onClick={() => setOpen(!open)} className="mt-2 text-[11px] font-bold tracking-wider uppercase text-[#5A2A3D] hover:text-[#B8956A] transition-colors flex items-center gap-1" aria-expanded={open} data-id="element-185">
            {open ? 'Ver menos' : 'Ver más'}
            <svg className={`w-3 h-3 transition-transform ${open ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5} data-id="element-186">
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" data-id="element-187" />
            </svg>
          </button>
        </div>
        <p className="hidden md:block text-[#5A4A4F] leading-relaxed text-sm md:text-base" data-id="element-188">
          {t.desc}
        </p>
      </div>
    </div>;
}
function BonoCard({
  b
}: {
  b: (typeof bonos)[number];
}) {
  const [open, setOpen] = useState(false);
  return <div className="bg-white border border-[#E8D5C4] rounded-2xl overflow-hidden flex flex-col shadow-sm hover:border-[#B8956A] hover:-translate-y-0.5 transition-all" data-id="element-189">
      {/* Image */}
      <div className="relative w-full aspect-[16/9] sm:aspect-[16/8] overflow-hidden bg-[#FAF6F0]" data-id="element-190">
        <img src={b.img} alt={b.alt} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-191" />
        <div className="absolute top-2 left-2 bg-white/95 backdrop-blur-sm text-[#B8956A] font-bold text-[10px] tracking-[0.2em] uppercase px-2.5 py-1 rounded-full shadow-sm" data-id="element-192">
          Bono {b.num}
        </div>
        <div className="absolute top-2 right-2 bg-[#5A2A3D] text-white font-bold px-2.5 py-1 rounded-full text-[10px] uppercase tracking-wider shadow-sm" data-id="element-193">
          Gratis
        </div>
      </div>

      <div className="p-4 sm:p-5 flex-1 flex flex-col" data-id="element-194">
        <h3 className="text-base sm:text-lg md:text-xl text-[#2D1A22] mb-1.5 leading-tight" data-id="element-195">
          {b.title}
        </h3>
        <p className="text-[#5A2A3D] italic text-xs sm:text-sm mb-3" data-id="element-196">
          {b.short}
        </p>

        {open && <p className="text-[#5A4A4F] text-xs sm:text-sm mb-3 leading-relaxed" data-id="element-197">
            {b.desc}
          </p>}

        <button type="button" onClick={() => setOpen(!open)} className="mb-3 text-[11px] font-bold tracking-wider uppercase text-[#5A2A3D] hover:text-[#B8956A] transition-colors self-start flex items-center gap-1" aria-expanded={open} data-id="element-198">
          {open ? 'Ver menos' : 'Ver detalles'}
          <svg className={`w-3 h-3 transition-transform ${open ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5} data-id="element-199">
            <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" data-id="element-200" />
          </svg>
        </button>

        <div className="mt-auto pt-3 border-t border-[#E8D5C4] flex items-center justify-between" data-id="element-201">
          <span className="text-[#B8956A]/70 line-through font-mono text-xs sm:text-sm" data-id="element-202">
            {b.value}
          </span>
          <span className="text-[#5A2A3D] font-bold text-[11px] sm:text-xs uppercase tracking-wider" data-id="element-203">
            Incluido
          </span>
        </div>
      </div>
    </div>;
}
export function SolutionSection() {
  return <section className="py-12 md:py-24 bg-white border-y border-[#E8D5C4]" data-id="element-204">
      <div className="max-w-6xl mx-auto px-4" data-id="element-205">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-8 md:mb-16" data-id="element-206">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 sm:px-4 sm:py-2 rounded-full bg-[#FAF6F0] text-[#B8956A] font-bold text-[10px] sm:text-xs tracking-[0.2em] uppercase mb-4 sm:mb-6 border border-[#E8D5C4]" data-id="element-207">
            🏆 Kit Lashista Tu Agenda Profesional™
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-6xl text-[#2D1A22] mb-3 sm:mb-4 leading-tight" data-id="element-208">
            4 Tomos <span className="italic" data-id="element-209">+</span> 4 Bonos
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-[#5A4A4F] italic" data-id="element-210">
            El Sistema N°1 para Lashistas Argentinas
          </p>
          <p className="text-xs sm:text-sm text-[#B8956A] mt-2 sm:mt-3 tracking-wider uppercase" data-id="element-211">
            Más de 320 páginas — Todo listo para implementar
          </p>
        </div>

        {/* Tomos Grid — compact mobile cards with expandable details */}
        <div className="grid sm:grid-cols-2 gap-3 sm:gap-5 md:gap-6 mb-8 md:mb-16" data-id="element-212">
          {tomos.map((t, i) => <TomoCard key={i} t={t} i={i} data-id="element-213" />)}
        </div>

        {/* Checklist */}
        <div className="max-w-3xl mx-auto bg-[#FAF6F0] border border-[#E8D5C4] rounded-2xl md:rounded-3xl p-5 sm:p-6 md:p-10 mb-12 md:mb-28" data-id="element-214">
          <h3 className="text-xl sm:text-2xl md:text-3xl text-[#2D1A22] mb-5 sm:mb-8 text-center" data-id="element-215">
            Cada tomo incluye:
          </h3>
          <div className="grid sm:grid-cols-2 gap-2.5 sm:gap-3 md:gap-4" data-id="element-216">
            {checklist.map((item, i) => <div key={i} className="flex items-start gap-2 sm:gap-3" data-id="element-217">
                <span className="text-[#B8956A] mt-0.5 shrink-0" data-id="element-218">✓</span>
                <span className="text-[#5A4A4F] font-medium text-xs sm:text-sm md:text-base" data-id="element-219">
                  {item}
                </span>
              </div>)}
          </div>
        </div>

        {/* Bonuses Header */}
        <div className="text-center max-w-3xl mx-auto mb-7 sm:mb-12" data-id="element-220">
          <div className="text-[10px] tracking-[0.3em] text-[#B8956A] font-bold uppercase mb-3" data-id="element-221">
            🎁 Siempre incluidos
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-6xl text-[#2D1A22] mb-3 sm:mb-4 leading-tight" data-id="element-222">
            4 Bonos <span className="italic" data-id="element-223">de Acción Inmediata</span>
          </h2>
        </div>

        {/* Bonuses Grid — compact cards with thumbnail + expandable */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5 mb-8 md:mb-16" data-id="element-224">
          {bonos.map((b, i) => <BonoCard key={i} b={b} data-id="element-225" />)}
        </div>

        {/* Total Value */}
        <div className="max-w-xl mx-auto text-center bg-[#FAF6F0] border border-[#B8956A]/40 rounded-2xl p-5 sm:p-6 md:p-8" data-id="element-226">
          <div className="text-[#B8956A] font-bold mb-2 uppercase tracking-[0.2em] text-[10px] sm:text-xs" data-id="element-227">
            Valor total bonos
          </div>
          <div className="text-xl sm:text-2xl md:text-3xl" data-id="element-228">
            <span className="line-through text-[#5A4A4F]/60 mr-2 sm:mr-3" data-id="element-229">
              $51.000
            </span>
            <span className="text-[#5A2A3D] italic" data-id="element-230">→ Gratis con tu Kit</span>
          </div>
        </div>
      </div>
    </section>;
}